import headerBackground from "../../Assets/Images/header-background-app.png";
import { useLocation } from "react-router-dom";
import ballerzLogo from "../../Assets/Images/ballerz-logo-white.png";
import homeIcon from "../../Assets/Images/home.png";
import { useParams, useNavigate } from "react-router-dom";

export default function HeaderPreRegistration(props) {
  const location = useLocation();

  const navigate = useNavigate();

  return (
    <>
      <header
        className="relative flex items-center justify-center px-8 py-16 bg-cover bg-center text-white"
        style={{
          backgroundImage: `url(${headerBackground})`,
        }}
      >
        {props.hideHome ? null : (
          <div
            onClick={() =>
              navigate(`/pre-registration/${props.bookingReference}`, {})
            }
            className="absolute left-2 sm:left-6 top-4 cursor-pointer p-1 rounded hover:bg-white/20"
          >
            <img
              src={homeIcon}
              alt="Home"
              className="h-16 w-16 sm:h-20 sm:w-20 sm:mt-0"
            />
          </div>
        )}

        <div className="flex justify-center">
          <img
            src={ballerzLogo}
            alt="Ballerz Logo"
            className="h-10 sm:h-14 object-contain"
          />
        </div>
      </header>
    </>
  );
}
